import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import { adminReviewRequestQueryOptions } from "@/lib/client/review";

export const Route = createFileRoute("/admin/queue/$id")({
  component: RouteComponent,
  preload: false,
  beforeLoad(ctx) {
    if (!ctx.location.pathname.endsWith("/view")) {
      throw redirect({ ...ctx, to: "/admin/queue/$id/view" });
    }
  },
  async loader({ context, params }) {
    await context.queryClient.ensureQueryData(adminReviewRequestQueryOptions(params.id));
  },
  pendingComponent: () => (
    <div className="size-full grid place-items-center">
      <Loader2 className="animate-spin" />
    </div>
  ),
});

function RouteComponent() {
  return <Outlet />;
}
